import React from "react";
import Nav from "react-bootstrap/Nav";
import _ from "underscore";
import MagazineMenu from "./MagazineMenu";
import DesignersMenu from "./DesignersMenu";
import ItemsMenu from "./ItemsMenu";
import connect from "react-redux/es/connect/connect";
import GiftsMenu from "./GiftsMenu";
import SalesMenu from "./SalesMenu";
import ItemsMenuReversedColumns from "./ItemsMenuReversedColumns";
import {generateCollectionPrefix, generateCollections, generateExtra, generateExtraPrefix} from "./helpers";
import {isBetweenDates} from "../common/utils";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

const initial_menus_state = {
    show_bags_menu: false,
    show_accessories_menu: false,
    show_watches_menu: false,
    show_jewelry_menu: false,
    show_apparel_menu: false,
    show_shoes_menu: false,
    show_designers_menu: false,
    show_magazine_menu: false,
    show_gifts_menu: false,
    show_sales_menu: false,
    active_key: '',
    isHidden: true
};

class HeaderMenuItem extends React.Component {
    constructor() {
        super();

        this.state = initial_menus_state;
        this.timer = 0;
        this.timerOut = 0;
        this.showMenus = this.showMenus.bind(this);
        this.hideMenus = this.hideMenus.bind(this);
        this.showHideMenus = this.showHideMenus.bind(this);
        this.isHidden = this.isHidden.bind(this);
    }

    showMenus(action, active_key) {
        if (action && !this.timer) {
            const next_menus_state = {
                ...initial_menus_state,
                ...action,
                active_key: active_key
            };
            if (this.timerOut) {
                window.clearTimeout(this.timerOut);
                this.timerOut = 0;
            }
            this.timer=window.setTimeout(
                () => {
                    this.setState(next_menus_state);
                }
                ,200);
        }
    }

    hideMenus() {
        if (!this.timerOut) {
            if (this.timer) {
                window.clearTimeout(this.timer);
                this.timer = 0;
            }
            this.timerOut=window.setTimeout(
                () => {
                    this.setState(initial_menus_state)
                }
                ,200);
        }
    }

    showHideMenus(action) {
        action ? this.showMenus(action) : this.hideMenus();
    }

    isHidden(e) {
        this.setState({isHidden: e})
    }

    render() {
        const {
            menu_item, class_name, mobile, designers, magazines, vault_articles, bc_filter_tree, user_profile,
        } = this.props;
        const {
            show_bags_menu, show_accessories_menu, show_watches_menu,
            show_jewelry_menu, show_apparel_menu, show_shoes_menu, show_designers_menu, show_magazine_menu,
            show_gifts_menu, show_sales_menu, active_key
        } = this.state;
        const is_b2b = user_profile ? user_profile.is_b2b : false;

        let collection_designers = [];
        if(show_jewelry_menu){
            collection_designers = _.filter(designers, (designer) => {
                return designer.show_in_jewelry === true;
            })
        }
        if(show_watches_menu){
            collection_designers = _.filter(designers, (designer) => {
                return designer.show_in_watches === true;
            })
        }
        if(show_apparel_menu){
            collection_designers = _.filter(designers, (designer) => {
                return designer.show_in_apparel === true;
            })
        }
        if(show_shoes_menu){
            collection_designers = _.filter(designers, (designer) => {
                return designer.show_in_shoes === true;
            })
        }

        let menu_item_sort = "";
        if (menu_item.sort) {
            menu_item_sort = menu_item.sort;
        }

        const header_menu_item_class = menu_item.className ? ' ' + menu_item.className : '';

        const collections = generateCollections(menu_item, bc_filter_tree);
        const collections_prefix = generateCollectionPrefix(collections);
        let extra = generateExtra(menu_item, bc_filter_tree);
        let extra_prefix = generateExtraPrefix(extra);

        if(menu_item.collections_info_key){
            extra = _.filter(designers, (designer) => {
                return designer[menu_item.collections_info_key];
            })
        }

        const location = new URL(window.location);

        if (menu_item.mouse_over && !mobile) {
            if(!is_b2b && menu_item.key === 'wholesale'){
                return null;
            }
            if(menu_item.available_between && !isBetweenDates(menu_item.available_between[0], menu_item.available_between[1])){
                return (
                    <OverlayTrigger
                        rootClose
                        placement={"bottom"}
                        trigger={['hover','focus']}
                        overlay={
                            <Popover id={`tooltip-wholesale`}>
                                <Popover.Content>
                                    {menu_item.tooltip}
                                </Popover.Content>
                            </Popover>
                        }
                    >
                        <Nav.Item
                            className={`${class_name + header_menu_item_class} nav-link`}
                        >
                            {menu_item.icon && <span className={`${menu_item.icon} icon`}/>}
                            {menu_item.title}
                        </Nav.Item>
                    </OverlayTrigger>
                )
            }
            return (
                <Nav.Item
                    className={`${class_name + header_menu_item_class} nav-link`}
                    onMouseOver={() => this.showMenus(menu_item.mouse_over, menu_item.key)}
                    onFocus={() => this.showMenus(menu_item.mouse_over, menu_item.key)}
                    onMouseLeave={() => this.hideMenus()}
                    onBlur={() => this.hideMenus()}
                >
                    <a className={`${(menu_item.key === active_key || location.pathname.indexOf(menu_item.url_slug) !== -1 || (location.pathname === "/collections/" && menu_item.key === "designers")) ? 'active' : ''}`} href={menu_item.href + menu_item_sort}>
                        {menu_item.icon && <span className={`${menu_item.icon} icon`}/>}
                        {menu_item.title}
                    </a>

                    {show_designers_menu &&
                    <DesignersMenu
                        menu_item={menu_item}
                        designers={designers}
                        show_designers_menu={show_designers_menu}
                    />
                    }

                    {show_magazine_menu &&
                        <MagazineMenu
                            articles={magazines}
                            vault_articles={vault_articles}
                        />
                    }

                    {show_gifts_menu &&
                        <GiftsMenu
                        className="red-text"
                        />
                    }

                    {show_sales_menu &&
                        <SalesMenu
                            collections={menu_item.collections}
                        />
                    }

                    {(show_bags_menu || show_accessories_menu || show_watches_menu || show_jewelry_menu) &&
                    <ItemsMenu
                        menu_item={menu_item}
                        collections={collections}
                        collections_prefix={collections_prefix}
                        extra={extra.values}
                        extra_prefix={extra_prefix}
                        designers={collection_designers}
                        show_designers_menu={show_designers_menu}
                    />
                    }
                    {(show_apparel_menu || show_shoes_menu) &&
                    <ItemsMenuReversedColumns
                        menu_item={menu_item}
                        collections={collections}
                        collections_prefix={collections_prefix}
                        extra={extra.values}
                        extra_prefix={extra_prefix}
                        designers={collection_designers}
                        show_designers_menu={show_designers_menu}
                    />
                    }
                </Nav.Item>
            )
        }
        if (menu_item.show_mobile) {
            if(menu_item.key === 'wholesale' && !is_b2b){
                return null;
            }
            if(menu_item.available_between && !isBetweenDates(menu_item.available_between[0], menu_item.available_between[1])){
                return (
                    <OverlayTrigger
                        rootClose
                        placement={"bottom"}
                        trigger={'click'}
                        onEnter={() => this.isHidden(false)}
                        onExited={() => this.isHidden(true)}
                        overlay={
                            <Popover id={`tooltip-wholesale`}>
                                <Popover.Content>
                                    {menu_item.tooltip}
                                </Popover.Content>
                            </Popover>
                        }
                    >
                        <Nav.Item
                            className={`${class_name + header_menu_item_class} nav-link`}
                        >
                            {menu_item.icon && <span className={`${menu_item.icon} icon`}/>}
                            {menu_item.title}
                        </Nav.Item>
                    </OverlayTrigger>
                )
            }

            return (
                <Nav.Item
                    className={`${class_name + header_menu_item_class} nav-link`}
                >
                    <a
                        href={menu_item.href + menu_item_sort}
                        className={location.pathname.indexOf(menu_item.url_slug) !== -1 ? 'active' : ''}
                    >
                        {menu_item.icon && <span className={`${menu_item.icon} icon`}/>}
                        {menu_item.title}
                    </a>
                </Nav.Item>
            )
        }
        return null;
    }
}

const mapStateToProps = function (state) {
    const {designers, magazines, stores} = state.appReducer.init;
    const {bc_filter_tree} = state.appReducer;
    const {user_profile} = state.myAccountReducer;
    return {designers, magazines, stores, bc_filter_tree, user_profile};
};

export default connect(mapStateToProps, null)(HeaderMenuItem);